export const getPullRequestNumberAsString = (
  fullBranchName?: string
): string => {
  return fullBranchName?.split("/").slice(-2)[0] || "";
};
